import React, { Component } from "react";
import axios from "axios";
import Cookies from 'js-cookie';
import "../../css/SignupForm.css";
import Footer from "../components/Footer.js";
import Modal from "./Modal";
import equis from "../../assets/eliminar.svg";
import info from "../../assets/Info.png";
import Header from '../../pages/components/Header.js';
import CenteredWrapper from '../components/CenteredWrapper.js'
import { CheckCircle } from '@material-ui/icons'; 

class SignupForm extends Component {
  constructor(props) {
    super(props);

    const identification = Cookies.get("identificacion");
    const tipoIdentification = (Cookies.get("tipo") || "").includes('cedula') ? "Cédula" : "Pasaporte";
    // if ((Cookies.get("tipo") || "").includes('cedula')) {
    //   const fechaNacimiento = "";
    //   const tipoIdentification = "Cédula";
    // }
    const fechaNacimiento = Cookies.get("fechanacimiento") || "";

    this.state = {
      formData: {
        tipoIdentificacion: tipoIdentification,
        identificacion: props.identificacion ?? identification ?? "",
        nombres: "",
        apellidos: "",
        sexo: "",
        fechaNacimiento: fechaNacimiento,
      },
      secondFormData: {
        correoElectronico: "",
        repetirCorreoElectronico: "",
        codigoVerificacion: ""
      },
      errors: {},
      modalError: false,
      modalMessage: {
        show: false,
        titulo: "",
        mensaje: "",
        imagen: "",
      },
      nombresRegla: "",
      activeButton: true,
      loading: false,
      showNombreField: false,
      showApellidoField: false,
      showSexoField: false,
      showFechaNacimientoField: false,
      showPinField: false, 
      showPasswordField: false,
      isLoading: true,
      hasError: false,
      hasErrorExtranjero: false,
      nombresTouched: false,
      apellidosTouched: false,
      sexoTouched: false,
      emailTouched: false, 
      repeatEmailTouched: false,
      verifyingPin: false,
      isPinValid: false,
      intentos:3,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSecondFormSubmit = this.handleSecondFormSubmit.bind(this);
    this.abrirModalError = this.abrirModalError.bind(this);
    this.cerrarModalError = this.cerrarModalError.bind(this);
    this.abrirModalMessage = this.abrirModalMessage.bind(this);
    this.cerrarModalMessage = this.cerrarModalMessage.bind(this);
    this.handleGeneratePin = this.handleGeneratePin.bind(this); 
    //this.validatePassword = this.validatePassword.bind(this);
    this.handleEmailBlur = this.handleEmailBlur.bind(this);
    this.handleRepeatEmailBlur = this.handleRepeatEmailBlur.bind(this);
    this.getIdentificationType = this.getIdentificationType.bind(this);
    this.validatePendingFields = this.validatePendingFields.bind(this);
    this.agregarNombresEnRegla = this.agregarNombresEnRegla.bind(this);
  }

  validatePendingFields() {
    const { nombres, apellidos, sexo, fechaNacimiento } = this.state.formData;

    this.setState({
      showNombreField: nombres == "",
      showApellidoField: apellidos == "",
      showSexoField: sexo == "",
      showFechaNacimientoField: fechaNacimiento == "" || fechaNacimiento == null,
    });

  }

  agregarNombresEnRegla() {
    var nombreString = "";
    var nombres = this.state.formData.nombres.split(" ");
    // var nombres_temp = nombres.split(" ");
    var apellidos = this.state.formData.apellidos.split(" ");
    // var apellidos_temp = apellidos.split(" ");

    var nombreCompleto = nombres.concat(apellidos);

    for (var i = 0; i < nombreCompleto.length; i++) {
        if (i == nombreCompleto.length - 1) {
            nombreString = nombreString.concat(nombreCompleto[i]);
        } else {
            nombreString = nombreString.concat(nombreCompleto[i] + ", ");
        }
    }
    this.setState({
        nombresRegla: nombreString
    })
  }

  getIdentificationType(Type) {
    /* Se deben agregar mas tipo en caso de existir */
    if (Type == 'Cédula') {
      return 'CED';
    } else {
      return 'PAS';  
    }    
  }

  handleVerifyPin = () => {
    const { codigoVerificacion, correoElectronico } = this.state.secondFormData;
    
    if (!codigoVerificacion) {
      this.setState({
        errors: {
          ...this.state.errors,
          codigoVerificacion: "Por favor ingrese el código de verificación",
        },
      });
      return;
    }

    this.setState({ verifyingPin: true });

    window.grecaptcha.ready(()=>{
      window.grecaptcha.execute(process.env.REACT_APP_CAPTCHAKEY, { action: 'submit' }).then(token =>{
        const requestBody = {
          email: correoElectronico,
          pin: codigoVerificacion
        };
        const config = {
          headers: {
            'X-Recaptcha-Token': token
          }
        };

        axios.post(`${process.env.REACT_APP_API_EXT}/Account/ValidarPin`, requestBody, config)
        .then((response) => {
          if (response.data?.status?.isSuccessfully && response.data?.data?.pinValidado) {
            // Caso exitoso: PIN válido
            this.agregarNombresEnRegla();
            setTimeout(() => {
              this.setState({
                isPinValid: true,
                verifyingPin: false,
                errors: {
                  ...this.state.errors,
                  codigoVerificacion: "",
                }
              });
            }, 750);
          } else {
            // Caso de error (PIN incorrecto u otro)
            const intentosRestantes = response.data?.data?.pinIntentosRestantes || 0;
            const errorMessage = 
                `El código de verificación es incorrecto${intentosRestantes 
                    ? ` Tiene ${intentosRestantes} intentos restantes para ingresar el código de verificación` 
                    : ''}`;

            this.setState({
                isPinValid: false,
                verifyingPin: false,
                errors: {
                    ...this.state.errors,
                    codigoVerificacion: errorMessage,
                }, 
                intentos:intentosRestantes

                
            });
            if(intentosRestantes==0)
              this.setState({
                showPinField: false,    
            });
          }
        })
        .catch((error) => {
            this.setState({
              isPinValid: false,
              verifyingPin: false,
              errors: {
                ...this.state.errors,
                codigoVerificacion: "No se pudo conectar con el servidor",
              }
            });
        });
      });
    });
  }

  handleEmailBlur() {
    const { correoElectronico } = this.state.secondFormData;
    const emailRegex = /^[^\s@]+@(gmail\.com|googlemail\.com|outlook\.(com|es|ec)|hotmail\.(com|es)|live\.com)$/i;
    
    this.setState({ emailTouched: true });
    
    if (!correoElectronico) {
      this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          correoElectronico: "El correo electrónico es obligatorio.",
        },
      }));
    } else if (!emailRegex.test(correoElectronico)) {
      this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          correoElectronico: "Ingrese un correo electrónico válido de Microsoft o Google (ejemplo@dominio.com).",
        },
      }));
    } else {
      this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          correoElectronico: "",
        },
      }));
    }
  }

  handleRepeatEmailBlur() {
    const { correoElectronico, repetirCorreoElectronico } = this.state.secondFormData;
    
    this.setState({ repeatEmailTouched: true });
    
    if (!repetirCorreoElectronico) {
      this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          repetirCorreoElectronico: "Debe repetir el correo electrónico.",
        },
      }));
    } else if (correoElectronico !== repetirCorreoElectronico) {
      this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          repetirCorreoElectronico: "Los correos electrónicos no coinciden.",
        },
      }));
    } else {
      this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          repetirCorreoElectronico: "",
        },
      }));
    }
  }

  componentDidMount() {
    this.props.useEffect();

    const MAX_ATTEMPTS = 50; // 50 intentos de 100ms = 5 segundos
    let attempts = 0;

    const { identificacion, tipoIdentificacion } = this.state.formData;

    const waitForRecaptcha = () => {
      if (window.grecaptcha && window.grecaptcha.ready){
        window.grecaptcha.ready(() => {
          if (identificacion && tipoIdentificacion === "Cédula"){
            this.fetchRegistroCivilData(identificacion);
          } else{
            this.fetchPasaporteExists(identificacion);
          }
        });
      } else if (attempts < MAX_ATTEMPTS){
        attempts++;
        setTimeout(waitForRecaptcha, 100);
      }else{
        console.error("❌ No se pudo cargar grecaptcha después de múltiples intentos.");
        this.setState({
          modalMessage: {
            show: true,
            titulo: "Error",
            mensaje: "No se pudo cargar la verificación de seguridad. Por favor recargue la página.",
            imagen: equis,
          }
        });
      }
    };

    waitForRecaptcha();
  }

  fetchRegistroCivilData(identificacion) {
    if (Cookies.get('fechanacimiento')) {
      Cookies.remove('fechanacimiento');
    }
    this.setState({ loading: true });
    window.grecaptcha.ready(()=>{
      window.grecaptcha.execute(process.env.REACT_APP_CAPTCHAKEY, { action: 'submit' }).then(token => {
        axios.get(`${process.env.REACT_APP_API_EXT}/Account/GetDatosRegistroCivil/${identificacion}`, {
          headers: {
            'X-Recaptcha-Token': token
          }
        })
        .then(response => {
          const { data } = response;
          if (data.status.isSuccessfully) {
            const { nombres, sexo, fechanacimiento, apellidopadre, apellidomadre } = data.data;
            const sexoCode = (sexo ?? '').trim().toUpperCase(); // "H" | "M"
            this.setState({
              formData: {
                ...this.state.formData,
                nombres: nombres,
                sexo: sexoCode === 'M' ? 'M' : sexoCode === 'F' ? 'F' : '',
                apellidos: `${apellidopadre} ${apellidomadre}`,
                fechaNacimiento: fechanacimiento.split('T')[0],
              },
              isLoading: false,
              loading: false
            });
            this.validatePendingFields();
          } else {
            this.setState({ 
              hasError: true,
              isLoading: false,
              loading: false
            });
          }
        })
        .catch(error => {
          console.error("Error fetching data: ", error);
          this.setState({ 
            hasError: true,
            isLoading: false,
            loading: false
          });
        });
      });
    });
  }

  fetchPasaporteExists(identificacion) {
    //no es necesario validar si existe, solo es tomar los datos que se puedan llenar para el form
    this.setState({ loading: true });
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(process.env.REACT_APP_CAPTCHAKEY, { action: 'submit' }).then(token => {
        axios.get(`${process.env.REACT_APP_API_EXT}/Account/VerificarExistenciaPersona/`, 
        {
          params: {
            tipoidentificacion: 'PAS',
            numidentificacion: identificacion
          },
          headers: {
            'X-Recaptcha-Token': token
          }
        })
        .then(response => {
          const { data } = response;
          if (data.status.isSuccessfully) {
            // const { nombres, sexo, fechanacimiento, apellidopadre, apellidomadre } = data.data;
            this.setState({
              // formData: {
              //   ...this.state.formData,
              //   nombres: nombres,
              //   sexo: sexo === "M" ? "Masculino" : "Femenino",
              //   apellidos: `${apellidopadre} ${apellidomadre}`,
              //   fechaNacimiento: fechanacimiento.split('T')[0],
              // },
              isLoading: false,
              loading: false
            });
            this.validatePendingFields();
          } else {
            this.setState({ 
              hasErrorExtranjero: true,
              isLoading: false,
              loading: false
            });
          }
        })
        .catch(error => {
          console.error("Error fetching data: ", error);
          this.setState({ 
            hasErrorExtranjero: true,
            isLoading: false,
            loading: false
          });
        });
      });
    });
  }

  handleChange(e) {
    const { name, value } = e.target;

    let newValue = value;
    if (name === "codigoVerificacion") {
      newValue = value.replace(/\D/g, "");
      if (newValue.length > 4) {
        newValue = newValue.slice(0, 4);
      }
    }
    
    if (Object.prototype.hasOwnProperty.call(this.state.secondFormData, name)) {
      this.setState(prevState => ({
        secondFormData: {
          ...prevState.secondFormData,
          [name]: newValue,
        },
        errors: { ...prevState.errors }
      }));
    } else {
      this.setState(prevState => ({
        formData: {
          ...prevState.formData,
          [name]: value,
        }
      }));}
  }

  handlerOnBlur = (event) => {
    const { name, value } = event.target;
    const errors = { ...this.state.errors };

    if (!value.trim()) {
      switch (name) {
        case 'nombres':                    
          this.setState(prevState => ({
            nombresTouched: true,
            errors: {
              ...prevState.errors,
              nombres: "Este campo es obligatorio."
            },
          }));
          break;
        case 'apellidos':
          this.setState(prevState => ({
            apellidosTouched: true,
            errors: {
              ...prevState.errors,
              apellidos: "Este campo es obligatorio."
            },
          }));
          break;
        case 'sexo':          
          this.setState(prevState => ({
            sexoTouched: true,
            errors: {
              ...prevState.errors,
              sexo: "Debe seleccionar una opción.."
            },
          }));
          break;
        default:
          break;        
      }
    } else {
      // Limpiar error si hay valor
      errors[name] = "";
      this.setState({
        errors
      });
    }
  };


  handleSubmit(e) {
    e.preventDefault();
    const { identificacion, nombres, apellidos, fechaNacimiento } = this.state.formData;

    // Validación simple antes de continuar
    let errors = {};
    if (!identificacion) errors.identificacion = "La identificación es obligatoria.";
    if (!nombres) errors.nombres = "El nombre es obligatorio.";
    if (!apellidos) errors.apellidos = "El apellido es obligatorio.";
    if (!fechaNacimiento) errors.fechaNacimiento = "Debe ingresar una fecha de nacimiento.";

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }


  }

  handleSecondFormSubmit(e) {
    e.preventDefault();
    const { correoElectronico, repetirCorreoElectronico, codigoVerificacion } = this.state.secondFormData;    
    const emailRegex = /^[^\s@]+@(gmail\.com|googlemail\.com|outlook\.(com|es|ec)|hotmail\.(com|es)|live\.com)$/i;

    let errors = {};
    if (!correoElectronico) {
      errors.correoElectronico = "El correo electrónico es obligatorio.";
    } else if (!emailRegex.test(correoElectronico)) {
      errors.correoElectronico = "Ingrese un correo electrónico válido (Microsoft o Google).";
    }
    if (!repetirCorreoElectronico) errors.repetirCorreoElectronico = "Debe repetir el correo electrónico.";
    if (correoElectronico !== repetirCorreoElectronico) errors.repetirCorreoElectronico = "Los correos electrónicos no coinciden.";
    if (!codigoVerificacion) errors.codigoVerificacion = "El código de verificación es obligatorio.";
    
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    this.handlePostJwtToken();    
  }

  handlePostJwtToken = () => {
    
    const { identificacion, nombres, apellidos, fechaNacimiento, sexo, tipoIdentificacion } = this.state.formData;
    const { correoElectronico, contrasena } = this.state.secondFormData;

    window.grecaptcha.ready(()=>{
      window.grecaptcha.execute(process.env.REACT_APP_CAPTCHAKEY, { action: 'submit' }).then(token => {
        const requestBody = {
          email: correoElectronico,      
          tipo_identificacion: this.getIdentificationType(tipoIdentificacion),
          identificacion: identificacion,
          nombres: nombres,
          apellidos: apellidos,      
          // password: contrasena,
          fecha_nacimiento: fechaNacimiento,
          sexo: sexo
        };

        const config = {
          headers: {
            'X-Recaptcha-Token': token
          }
        };
        
        axios.post(`${process.env.REACT_APP_API_EXT}/Account/ObtenerTokenRegistro`, requestBody, config)
        .then((response) => {
          if (response.data?.status?.isSuccessfully && response.data?.data?.jwtToken) {
            // Guardar en Cookies y redirigir
            Cookies.set("token", response.data.data.jwtToken);
            window.location.href = '/acuerdoexternos';

          } else {
            this.setState({
              modalMessage: {
                show: true,
                titulo: "Error",
                mensaje: response.data.status.messages[0],
                imagen: equis,
              }
            });
          }
        })
        .catch((error) => {
          this.setState({
              modalMessage: {
                  show: true,
                  titulo: "Error",
                  mensaje: "Ocurrió un error en el servidor.",
                  imagen: equis,
              }
          });
        });
      });
    });
  }

  abrirModalError() {
    this.setState({ modalError: true });
  }

  cerrarModalError() {
    this.setState({ modalError: false });
  }

  abrirModalMessage() {
    this.setState({
      modalMessage: {
        ...this.state.modalMessage,
        show: true,
      },
    });
  }

  cerrarModalMessage() {
    this.setState({
      modalMessage: {
        titulo: "",
        mensaje: "",
        imagen: "",
        show: false,
      },
    });
  }


  handleGeneratePin() {
    const { correoElectronico } = this.state.secondFormData;
  
    // Validar que el correo electrónico esté presente
    if (!correoElectronico) {
      this.setState({
        errors: { correoElectronico: "Debe ingresar un correo electrónico válido." },
      });
      return;
    }
  
    this.setState({ loading: true }); 
    
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(process.env.REACT_APP_CAPTCHAKEY, { action: 'submit' }).then(token =>{
        //aqui se debe validar que el correo no este registrado previamente en tablas
        axios.get(`${process.env.REACT_APP_API_EXT}/Account/VerificarExistenciaEmail`, {
            params: {
                email: correoElectronico
            },
            headers: {
                'X-Recaptcha-Token': token
            }
        })
        .then(response => {
          if (response.data.status.isSuccessfully && response.data.data.respuesta) {
              this.setState({
                  modalMessage: {
                      show: true,
                      titulo: "ATENCIÓN",
                      mensaje: "Ya existe una cuenta registrada con ese correo electrónico.",
                      imagen: equis,
                  },
                  loading: false, 
              });
          } else {
            const requestBody = {
              email: correoElectronico
            };
            axios.post(`${process.env.REACT_APP_API_EXT}/Account/GenerarPin`, requestBody)
            .then((response) => {
              if (response.data?.status?.isSuccessfully) {
                this.setState({
                  showPinField: true, 
                  secondFormData: {
                    ...this.state.secondFormData,
                  },
                  loading: false, 
                });
              }else{
                this.setState({
                  modalMessage: {
                    show: true,
                    titulo: "Error",
                    mensaje: response.data.status.messages[0],
                    imagen: equis, 
                  },
                  loading: false, 
                });
              }
            })
            .catch((error) => {
              this.setState({
                modalMessage: {
                  show: true,
                  titulo: "Error",
                  mensaje: "Ocurrió un error en el servidor, no se pudo generar el PIN. Intente nuevamente.",
                  imagen: equis, 
                },
                loading: false, 
              });
            });
          }
        })
        .catch(error => {            
            this.setState({
                modalMessage: {
                    show: true,
                    titulo: "Error",
                    mensaje: "Ocurrió un error en el servidor.",
                    imagen: equis,
                }
            });
        });
      });
    });  
  }

  render() {
    const { showPinField, formData, secondFormData, errors, isLoading, hasError, hasErrorExtranjero, nombresTouched, apellidosTouched, sexoTouched, emailTouched, repeatEmailTouched, isPinValid } = this.state;
    const { nombres, apellidos, sexo } = formData;
    const { correoElectronico, repetirCorreoElectronico } = secondFormData;
    //const passwordValidation = secondFormData.contrasena ? this.validatePassword(secondFormData.contrasena) : null;

    // Calculate email validation states
    const emailRegex = /^[^\s@]+@(gmail\.com|googlemail\.com|outlook\.(com|es|ec)|hotmail\.(com|es)|live\.com)$/i;
    const isEmailValid = correoElectronico && emailRegex.test(correoElectronico);
    const isRepeatEmailValid = repetirCorreoElectronico && correoElectronico === repetirCorreoElectronico;
    const isNombresValid = nombres.trim() !== "";
    const isApellidosValid = apellidos.trim() !== "";
    const isSexoValid = sexo.trim() !== "";
    const isEditable = this.state.showNombreField;
    
    const emailInputClass = `form-control ${
      emailTouched 
        ? isEmailValid 
          ? 'is-valid' 
          : errors.correoElectronico 
            ? 'is-invalid' 
            : ''
        : ''
    }`;
    
    const repeatEmailInputClass = `form-control ${
      repeatEmailTouched 
        ? isRepeatEmailValid 
          ? 'is-valid' 
          : errors.repetirCorreoElectronico 
            ? 'is-invalid' 
            : ''
        : ''
    }`;

    const nombresInputClass = `form-control ${
      isEditable ? 'editable-field' : 'readonly-field'
    } ${
      nombresTouched 
        ? isNombresValid 
          ? 'is-valid' 
          : errors.nombres 
            ? 'is-invalid' 
            : ''
        : ''
    }`;

    const apellidosInputClass = `form-control ${
      isEditable ? 'editable-field' : 'readonly-field'
    } ${
      apellidosTouched 
        ? isApellidosValid 
          ? 'is-valid' 
          : errors.apellidos 
            ? 'is-invalid' 
            : ''
        : ''
    }`;

    const sexoInputClass = `form-control ${
      isEditable ? 'editable-field' : 'readonly-field'
    } ${
      sexoTouched 
        ? isSexoValid 
          ? 'is-valid' 
          : errors.sexo 
            ? 'is-invalid' 
            : ''
        : ''
    }`;

    if (isLoading) {
      return (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Cargando...</span>
          </div>
          <p>Cargando datos...</p>
        </div>
      );
    }

    if (hasError) {
      return (
        <div className="alert alert-danger text-center">
          No se pudieron cargar los datos del registro civil. Por favor vuelva intentarlo.
        </div>
      );
    }

    if (hasErrorExtranjero) {
      return (
        <div className="alert alert-danger text-center">
          No se pudieron cargar los datos del pasaporte. Por favor vuelva intentarlo.
        </div>
      );
    }
    return (
      <div className="page">
        <Header />
        <main className="page-main">
        <CenteredWrapper>
          <div className="registro-container">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <h2 className="registro-title">CREAR CUENTA</h2>
                </div>
              </div>
    
              <form onSubmit={this.handleSubmit}>
                <div className="row-form gx-5">
                  <div className="row-form-datos">
                    {/* Tipo de Identificación */}
                    <div className="form-field col-md-8 mb-3">
                      <label 
                        className="form-label  text-start w-100"
                        style={{ color: "rgb(80, 110, 163)" }}
                      >
                        Tipo de Identificación
                      </label>
                      <div className="select-wrapper position-relative">
                        <input 
                          type="text" 
                          className="form-control readonly-field"
                          name="tipoIdentificacion" 
                          value={this.state.formData.tipoIdentificacion || ""} 
                          onChange={this.handleChange} 
                          disabled
                          placeholder="Tipo de Identificación"
                        />
                      </div>
                    </div>
      
                    {/* Identificación */}
                    <div className="form-field col-md-8 mb-3">
                      <label 
                        className="form-label  text-start w-100"
                        style={{ color: "rgb(80, 110, 163)" }}
                      >
                        Número de Identificación
                      </label>
                      <input
                        type="text"
                        name="identificacion"
                        placeholder="099999999"
                        className="form-control readonly-field"
                        value={this.state.formData.identificacion}
                        disabled
                      />
                      {this.state.errors.identificacion && <p className="text-danger">{this.state.errors.identificacion}</p>}
                    </div>
      
                    {/* Nombre */}
                    <div className="form-field col-md-8 mb-3">
                      <label 
                        className="form-label  text-start w-100"
                        style={{ color: "rgb(80, 110, 163)" }}
                      >
                        Nombre(s)
                      </label>
                      <input
                        type="text"
                        name="nombres"
                        placeholder="Ingresar nombre"
                        className={nombresInputClass}
                        value={this.state.formData.nombres}
                        onChange={this.handleChange}
                        onBlur={this.handlerOnBlur}
                        disabled={!this.state.showNombreField}
                      />
                      {errors.nombres && (
                        <div className="invalid-feedback d-block">
                          {errors.nombres}
                        </div>
                      )}                      
                    </div>
      
                    {/* Apellido */}
                    <div className="form-field col-md-8 mb-3">
                      <label 
                        className="form-label  text-start w-100"
                        style={{ color: "rgb(80, 110, 163)" }}
                      >
                        Apellido(s)
                      </label>
                      <input
                        type="text"
                        name="apellidos"
                        placeholder="Ingresar apellido"
                        className={apellidosInputClass}
                        value={this.state.formData.apellidos}
                        onChange={this.handleChange}
                        onBlur={this.handlerOnBlur}
                        disabled={!this.state.showApellidoField}
                      />
                      {errors.apellidos && (
                        <div className="invalid-feedback d-block">
                          {errors.apellidos}
                        </div>
                      )}                      
                    </div>
      
                    {/* Sexo */}
                    <div className="form-field col-md-8 mb-3">
                      <div className="input-wrapper position-relative">
                        <label 
                          className="form-label  text-start w-100"
                          style={{ color: "rgb(80, 110, 163)" }}
                        >
                          Sexo
                        </label>
                        <select
                          className={sexoInputClass}
                          name="sexo"
                          value={this.state.formData.sexo || ""}
                          onChange={this.handleChange}
                          onBlur={this.handlerOnBlur}
                          disabled={!this.state.showSexoField}
                        >
                          <option value="" disabled>Seleccionar sexo</option>
                          <option value="M">Hombre</option>
                          <option value="F">Mujer</option>
                        </select>
                        {errors.sexo && (
                          <div className="invalid-feedback d-block">
                            {errors.sexo}
                          </div>
                        )}
                      </div>
                    </div>

      
                    {/* Fecha de Nacimiento */}
                    <div className="form-field col-md-8 mb-3">
                      <div className="position-relative">
                        <label 
                          className="form-label  text-start w-100"
                          style={{ color: "rgb(80, 110, 163)" }}
                        >
                          Fecha de nacimiento
                        </label>
                        <input
                          type="date"
                          name="fechaNacimiento"
                          className="form-control readonly-field"
                          value={this.state.formData.fechaNacimiento}
                          onChange={this.handleChange}                          
                          disabled={!this.state.showFechaNacimientoField}
                        />
                      </div>
                      {this.state.errors.fechaNacimiento && <p className="text-danger">{this.state.errors.fechaNacimiento}</p>}
                    </div>
                  </div>
      
                  
                  <div className="form-field col-12 mt-2 mb-3">
                    <span className="text-teal fw-semibold" style={{ color: '#3b72ac' }}>Ingrese la siguiente Información</span>
                  </div>

                  {/* Correo Electrónico */}
                  <div className="row-form-correo">
                    <div className="form-field col-md-4 mb-3">
                      <label 
                        className="form-label  text-start w-100"
                        style={{ color: "rgb(80, 110, 163)" }}
                      >
                        Correo Electrónico
                      </label>
                      <input
                        type="email"
                        name="correoElectronico"
                        placeholder="Email de Google o Microsoft"
                        className={emailInputClass}
                        value={correoElectronico}
                        onChange={this.handleChange}
                        onBlur={this.handleEmailBlur}
                        disabled={this.state.showPinField}  
                      />
                      {errors.correoElectronico && (
                        <div className="invalid-feedback d-block">
                          {errors.correoElectronico}
                        </div>
                      )}
                      {emailTouched && isEmailValid && (
                        <div className="valid-feedback d-block">
                          Correo electrónico válido
                        </div>
                      )}
                    </div>
      
                    {/* Repetir Correo Electrónico */}
                    <div className="form-field col-md-4 mb-3">
                      <label 
                        className="form-label  text-start w-100"
                        style={{ color: "rgb(80, 110, 163)" }}
                      >
                        Repetir Correo Electrónico
                      </label>
                      <input
                        type="email"
                        name="repetirCorreoElectronico"
                        placeholder="Repetir Correo Electrónico"
                        className={repeatEmailInputClass}
                        value={repetirCorreoElectronico}
                        onChange={this.handleChange}
                        onBlur={this.handleRepeatEmailBlur}
                        onPaste={(e) => e.preventDefault()}
                        disabled={this.state.showPinField}  
                      />
                      {errors.repetirCorreoElectronico && (
                        <div className="invalid-feedback d-block">
                          {errors.repetirCorreoElectronico}
                        </div>
                      )}
                      {repeatEmailTouched && isRepeatEmailValid && (
                        <div className="valid-feedback d-block">
                          Los correos coinciden
                        </div>
                      )}
                    </div>
                  </div>
    
                  {/* Botón Generar PIN - Only show if emails are valid and match */}
                  {isEmailValid && isRepeatEmailValid && !isPinValid && (
                  <div className="col-12 text-center mt-2 mb-2">
                    <button
                      type="button"
                      className={`ext-btn-submit${showPinField ? '-disabled' : ''}`}
                      onClick={this.handleGeneratePin}
                      disabled={showPinField || this.state.loading}
                    >
                      {this.state.loading ? (
                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      ) : (
                        "Generar PIN"
                      )}
                    </button>
                    {showPinField && (
                      <div className="valid-feedback d-block">
                        Se ha enviado un pin de cuatro números a su correo electrónico. Digite a continuación:
                      </div>
                    )}
                  </div>
                )}

                  {/* Campo de Código de Verificación */}
                  {showPinField && !isPinValid && (
                  <>
                  <div className="validar-pin-row col-md-6 offset-md-3 mt-1">
                    <div className="input-group">
                      <input
                        type="text"
                        name="codigoVerificacion"
                        placeholder="Ingresar el Pin de Verificación"
                        className="form-control"
                        value={secondFormData.codigoVerificacion}
                        onChange={this.handleChange}
                        disabled={this.state.isPinValid}
                        maxLength={4}
                        inputMode="numeric"
                        pattern="\d{4}"
                      />
                      <button
                        type="button"
                        className={`ext-btn-submit ${this.state.isPinValid ? 'disabled' : ''}`}
                        onClick={this.handleVerifyPin}
                        disabled={!secondFormData.codigoVerificacion || this.state.verifyingPin || this.state.isPinValid}
                      >
                        {this.state.verifyingPin ? (
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        ) : (
                          "Validar PIN"
                        )}
                      </button>
                    </div>
                    {errors.codigoVerificacion && <p className="text-danger small mt-1">{errors.codigoVerificacion}</p>}                                        
                  </div>                      
                  </>
                  )}
                </div>

                {/* Success message when PIN is valid */}
                {isPinValid && (
                  <div className="pin-alert-message">
                    <div className="alert alert-success mt-2 d-flex align-items-center">
                      <CheckCircle style={{marginRight: '2px', fontSize: '20px'}} /> {/* Ícono de Material-UI */}
                      <div>PIN verificado correctamente</div>
                    </div>
                  </div>
                )}

                {/* Botón de Crear Cuenta */}
                {isPinValid && (
                  <div className="text-center mt-3">
                  <button
                    type="button"
                    className={
                      this.state.loading
                        ? 'ext-btn-submit-disabled'
                        : 'ext-btn-submit'
                    }
                    disabled={
                      this.state.loading
                    }
                    onClick={this.handleSecondFormSubmit}
                  >
                    {this.state.loading ? 'Cargando...' : 'Seguir'}
                  </button>
                  </div>
                )}
              
              </form>
            </div>
          </div>
        </CenteredWrapper>
        </main>
        <Footer />
        {/* Modal de Mensaje */}
        {this.state.modalMessage.show && (
          <Modal isOpen={this.state.modalMessage.show} cerrarModal={this.cerrarModalMessage} verBoton={true} textoBoton="ACEPTAR">
            <p className="text-center">
              <strong>{this.state.modalMessage.titulo}</strong>
            </p>
            <div className="mt-6 mb-6" align="center">
              <img className="registro-check-ext" src={this.state.modalMessage.imagen} alt="Exitoso"></img>
            </div>
            <p className="text-center">{this.state.modalMessage.mensaje}</p>
          </Modal>
        )}
      </div>
    );
  }
}

export default SignupForm;